import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

// Estilos para el PDF
const styles = StyleSheet.create({
  textareaLabel: {
    fontSize: 12,
    textAlign: 'justify',
    marginBottom: 8,
    lineHeight: 1.5,
    fontWeight: 'bold', // Para resaltar el texto
    fontFamily: 'Times-Bold',
    marginTop: 10
  },

  textarea: {
    fontSize: 12,
    borderWidth: 1,
    borderColor: '#000',
    padding: 10,
    borderRadius: 5,
    width: '100%',  // Ajuste automático al ancho disponible
    minHeight: 40,  // Asegura que tenga un mínimo de altura
    flexShrink: 1,  // Permite que el contenedor ajuste su tamaño según el contenido
    backgroundColor: '#f0f0f0',
    textAlign: 'justify',
    marginBottom: 8,
    lineHeight: 1.5,
  },
});
const TextAreaLabel = ({ label, value }) => {

  return (
    <View>
      <Text style={styles.textareaLabel}>- {label}</Text>
      <Text style={styles.textarea}>
        {value}
      </Text>
    </View>
  );
};

export default TextAreaLabel;
